import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiKoreksiFiskalService = new CrudCustom('/transaksi-koreksi-fiskals');
export default TransaksiKoreksiFiskalService;
